import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

function NoteControl(props) {
  const {
    display = {},
    label,
    noteVariant,
    variant,
  } = props;
  const allowedVariants = new Set(['default', 'subtle', 'info', 'customer']);
  const resolvedVariant = allowedVariants.has(noteVariant)
    ? noteVariant
    : allowedVariants.has(variant)
      ? variant
      : 'default';
  const isSubtle = resolvedVariant === 'subtle';
  const isInfo = resolvedVariant === 'info';
  const isCustomer = resolvedVariant === 'customer';

  return (
    <Box
      sx={{
        backgroundColor: isCustomer
          ? '#F4F8FF'
          : isInfo
            ? '#F4F8FF'
            : isSubtle
              ? '#F8FAFC'
              : '#F7FAFF',
        border: isCustomer
          ? '1px solid #DCE7FF'
          : isInfo
            ? '1px solid #DCE7FF'
            : isSubtle
              ? '1px solid #E5E7EB'
              : '1px solid #DCE5F1',
        borderLeft: isCustomer
          ? '4px solid #CBD5E1'
          : isInfo
            ? '4px solid #3B82F6'
            : undefined,
        borderRadius: isCustomer ? '10px' : isInfo ? '10px' : isSubtle ? '10px' : '12px',
        boxShadow: isCustomer ? 'none' : isInfo ? 'none' : isSubtle ? 'none' : '0 1px 0 rgba(13, 38, 76, 0.05)',
        mb: 2,
        padding: isCustomer ? '10px 14px' : isInfo ? '10px 14px' : isSubtle ? '10px 14px' : '12px 16px',
        ...display?.boxStyle,
      }}
    >
      <Typography
        style={{
          color: isCustomer ? '#9CA3AF' : isInfo ? '#2F4A73' : isSubtle ? '#9CA3AF' : '#8A97A6',
          fontSize: '13px',
          fontStyle: 'normal',
          lineHeight: 1.4,
          ...display?.labelStyle,
        }}
        variant="body2"
      >
        {label}
      </Typography>
    </Box>
  );
}

export default NoteControl;

NoteControl.propTypes = {
  display: PropTypes.shape({
    labelStyle: PropTypes.object,
    boxStyle: PropTypes.object,
  }),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  noteVariant: PropTypes.oneOf([
    'default',
    'subtle',
    'info',
    'customer',
  ]),
  variant: PropTypes.oneOf([
    'default',
    'subtle',
    'info',
    'customer',
  ]),
};

NoteControl.defaultProps = {
  display: {},
  label: '',
  noteVariant: undefined,
  variant: undefined,
};
